import React from 'react'
import { Link } from 'react-router-dom'
import { MenuItem } from '@mui/material'
import './navBar.css'
import { linkTarget } from '../../utils'

export interface INavBarMenuItem {
  url: string
  title: string
  handleClose?(event: React.MouseEvent): void
}

export default function NavBarMenuItem(props: INavBarMenuItem) {
  return (
    <MenuItem
      className='menu-item-navbar'
      disableTouchRipple
      onClick={(event) => {
        props.handleClose!(event)
      }}
      component={Link}
      target={linkTarget()}
      to={props.url}
    >
      {props.title}
    </MenuItem>
  )
}
